import { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useAppSelector } from "../../redux/hooks";
  import Hooks from "../utils/hooks";
import { Spin } from 'antd';

const spinnerStyles:any = {
    position:"absolute",
    left: 0,
    right: 0, 
    top:'40%',
    marginLeft: "auto", 
    marginRight: "auto",
  }
const Montage = () => {
  const params = useParams<any>()
  const [loadingMontage, setLoadingMontage] = useState(true)
  const {  getMontage } = Hooks();
  const urlMontage = useAppSelector((state) => state.MediaReducer.urlMedia);
  const history = useHistory();
  const location = useLocation();



  useEffect(() => {
    (async () => {
      await getMontage(params?.id);
      setLoadingMontage(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.id]);
  function goToMediasWithMontage() {
  
    // Parse existing query params
    const params = new URLSearchParams(location.search);
  
    // Add or update isMontage
    params.set("videos", "offline");
  
    // Push new URL with merged params
    history.push(`/ws-media/medias?${params.toString()}`);
  }
  useEffect(() => {
    // Update the language when it changes
    const handleLanguageChange = (event: MessageEvent) => {
     if (event.data?.info === "save_montage"){
        window.parent.postMessage({ info: 'save_montage' }, '*');
        goToMediasWithMontage()

      }
    };

    window.addEventListener("message", handleLanguageChange);

    return () => {
      window.removeEventListener("message", handleLanguageChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
        {loadingMontage 
      ? <Spin style={spinnerStyles} size="large" />
      : <iframe
          title={urlMontage}
          className="iframeVideo"
          id="iframe_list"
          allowFullScreen
          frameBorder="0"
          src={urlMontage}
        ></iframe>
      }
    </>
  )
}

export default Montage